import { renderNonCmsPage } from '@utils/non-cms-page'
import { PgPageProps } from './[[...slug]]'

import { TmGeneric } from '@templates/tm-generic'
import { getHeaderAndFooter, getPageBySlug } from '@services/contentful'
import GoogleMaps from '@utils/google-maps'

export const getStaticProps = async () => {
  const props = (await getPageBySlug('contact-us', false)) as PgPageProps

  if (!props) {
    return {
      notFound: true,
    }
  }
  const { footerContentful, headerContentful } = await getHeaderAndFooter(props, false)
  return {
    props: {
      ...props,
      footer: footerContentful,
      header: headerContentful,
      notFound: false,
      revalidate: 10, // Added the revalidate option to trigger incremental static regeneration.
    },
  }
}

const ContactUs = (props: PgPageProps) => {
  return renderNonCmsPage(
    'Contact Us',
    { ...props, slug: 'contact-us' },
    <div>
      <GoogleMaps></GoogleMaps>

      <TmGeneric blocks={props.blocks}></TmGeneric>
    </div>,
  )
}

export default ContactUs
